import { createContext, useContext, useState } from "react";

// Lets a page override the raw URL path shown in the Header breadcrumb (e.g.
// "companies/7/edit") with something human-readable (e.g.
// "companies/Acme Ltd/edit") once it has the data to do so. Header falls
// back to the raw path whenever no page has set one.
export const PageTitleContext = createContext([null, () => {}]);

export function PageTitleContextProvider({ children }) {
  const [pageTitle, setPageTitle] = useState(null);
  return (
    <PageTitleContext.Provider value={[pageTitle, setPageTitle]}>
      {children}
    </PageTitleContext.Provider>
  );
}

export function usePageTitle() {
  return useContext(PageTitleContext);
}
